import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["addressInput", "cityInput", "citySelect", "countrySelect"]

  static values = {mode: String, autocompleteId: String}

  #autocompleteInput
  #mode
  #childrenCount
  #childrenConnected

  initialize() {
    this.onInputChanged = this.onInputChanged.bind(this)
  }

  connect() {
    this.#childrenCount = 0
    this.#childrenConnected = 0
    this.element.addEventListener("initialized", this.childInitialized.bind(this));
    this.element.addEventListener("connected", this.childConnected.bind(this));
    this.element[this.identifier] = this;
    // Check si on est en mode autocomplete
    if (this.hasAutocompleteIdValue) {
      // On recupere l input autocomplete grace a l uniq id genere dans le composant (car a l exterieur du data-controller)
      this.#autocompleteInput = document.querySelector(`[data-id='${this.autocompleteIdValue}']`)
      if (this.#autocompleteInput) {
        // On surveille les changements auto sur l addresse pour verifier qu on ait bien selectionne un element parmi la liste
        this.addressInputTarget.addEventListener("change", this.onInputChanged)
      }
    }
    this.#mode = this.modeValue || "auto"
  }

  childInitialized() {
    // Used to count nested stimulus controllers and watch their connected state
    this.#childrenCount += 1
  }

  childConnected() {
    // Used to count nested stimulus controllers and watch their connected state
    this.#childrenConnected += 1
    if (this.#childrenConnected >= this.#childrenCount) {
      // All connected
      this.onCountryChange()
    }
  }
  disconnect() {
    if (this.#autocompleteInput) {
      this.addressInputTarget.removeEventListener("change", this.onInputChanged)
    }
  }

  onInputChanged(e) {
    const formGroup = this.#autocompleteInput.closest(".oq-form-group")
    const fieldError = formGroup.querySelector(".field-error")
    if (!this.addressInputTarget.value) {
      // Si l input adresse est vide (= clear lorsqu on cherche une nouvelle adresse) on affiche une erreur sous l input autocomplete
      formGroup.classList.add("is-invalid")
      fieldError.innerText = "Veuillez sélectionner une adresse parmi la liste."
    } else {
      formGroup.classList.remove("is-invalid")
      fieldError.innerText = ""
    }
  }

  onCountryChange() {
    console.log("on country changed")
    const cityInputGroup = this.cityInputTarget.closest(".oq-form-group")
    const citySelectGroup = this.citySelectTarget.closest(".oq-form-group")

    if (this.#mode == "auto") {
      cityInputGroup.classList.add("hidden")
      citySelectGroup.classList.add("hidden")
    } else {
      const country = this.countrySelectTarget["form--collection-select--component"].valueText
      if (country == "France") {
        cityInputGroup.classList.add("hidden")
        this.cityInputTarget.value = ""
        citySelectGroup.classList.remove("hidden")
      } else {
        // Si pays etranger on laisse la possibilite de renseigner le nom de la ville
        cityInputGroup.classList.remove("hidden")
        citySelectGroup.classList.add("hidden")
        this.citySelectTarget["form--collection-select--component"].clearValue()
      }
    }
  }

  selectAutoMode() {
    this.#mode = "auto"
    this.onCountryChange()
  }

  selectManualMode() {
    this.#mode = "manual"
    this.onCountryChange()
  }
}
